import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform, Content, AlertController, Events, ModalController,Slides } from 'ionic-angular';
import { RouteProvider } from '../../providers/route/route';
import { HttpProvider } from '../../providers/http/http';
import { AuthProvider, BiometricLoginFailureReason } from '../../providers/authorization/auth';
import { StorageProvider } from '../../providers/storage/storage';
import { StorageType } from '../../model/types/storage-type';
import { CustomerProvider } from '../../providers/customer/customer';
import { LoggerProvider, LoggerEvent } from '../../providers/logger/logger';
import { MarketingProvider } from '../../providers/marketing/marketing';
import { AppVersion } from '@ionic-native/app-version';
import { TranslateService } from '@ngx-translate/core';
import { RmtPopupComponent } from '../../components/rmt-popup/rmt-popup';
import { SegmentProvider } from '../../providers/analytics/segment';
import { getSourceAnalyticsData } from '../../providers/analytics/deeplink-source';
import { AnalyticsEventType, AnalyticsPhoneVerification, SegmentLocationNames } from '../../model/types/analytics.const';
import { RegisterProvider } from '../../providers/register/register';
// import { Sim } from 'ionic-native';
import { APP_CONFIG, Env, Region } from '../../environment';
import { LoadingProvider } from '../../providers/loading/loading';
import { ErrorCodeType } from '../../model/types/error-code-type';
import { DeeplinkProvider } from '../../providers/marketing/deeplink';
import { SystemProvider } from '../../providers/system/system';
import { LoginProvider } from '../../providers/myria/login-provider';
import { AuthMapper } from '../../providers/authorization';
import { IovationProvider } from '../../providers/iovation/iovation';
import { FeatureFlagTypes, UtilsProvider } from '../../providers/myria/utils-provider';
import { brandings } from '../../environment/branding/brandings'
import { FirebaseAnalyticsProvider } from '../../providers/analytics/firebase-analytics';
import { ResourceProvider } from '../../providers/resource/resource';
import { RmtSnackbarComponent } from '../../components/rmt-snackbar/rmt-snackbar';
import { RmtDebugMenuComponent } from '../../components/rmt-debug-menu/rmt-debug-menu';
import * as $ from 'jquery'
import { SendFlowProvider } from '../../providers/send-flow/send-flow';
import { VueProvider } from '../../providers/vue/vue';
import { CommonProvider } from '../../providers/common/common';
import { VueBridgeState } from '../../providers/vue/vue-helpers';
import { SigninPage } from '../../pages/signin/signin';
import { LITE_REGISTRATION_FIELDS } from '../../providers/myria/app-variables';
import { HiddenMenuProvider } from '../../providers/hidden-menu/hidden-menu';

// declare let device;
declare let window;
declare var require: any;

@IonicPage()
@Component({
  selector: 'page-pre-login-stories',
  templateUrl: 'pre-login-stories.html',
})
export class PreLoginStoriesPage {
  @ViewChild('language') language;
  @ViewChild(Content) content: Content;
  @ViewChild(Slides) slides: Slides;
  @ViewChild('video', { read: ElementRef }) videoRef;
  @ViewChild("img") set imgElement(img: ElementRef) {
  }
  @ViewChild("progress") set progressElement(progress: any) {
    this.slides.onlyExternal = true;
    if (progress && !this.showSplashscreen) {
      progress = progress.nativeElement;

      progress.addEventListener("animationend", () => { this.nextStoryItem(); });
      progress.addEventListener("webkitAnimationEnd", () => { this.nextStoryItem(); });
    }
  }
  langParams;
  showSplashscreen: boolean = true;
  splashScreenOpacity: number = 1.0;
  faceId: boolean = false;
  touchId: boolean = false;
  redirected: boolean = false;
  anim = null;
  animLoading = null;
  animLanding = null;
  offers;
  enterPromise;
  enterResolve;
  info = null;
  enabled: boolean = false;
  showEnvironmentConfigDetails: boolean = false;
  showEnvironmentConfig: boolean = false;
  environmentConfigText;
  environment = APP_CONFIG.env;
  showFrame: boolean = APP_CONFIG.previewFrame;
  deviceToken = null;
  api = APP_CONFIG.API_URL;
  apis;
  branding = APP_CONFIG.branding;
  itemHeader = "";
  brandParams = {
    brand: this.branding.partnerName ? this.branding.partnerName : "Ria",
  };
  reminderDuration = 'Monthly';

  displayGenericHome: boolean = true;
  appInfo = "unknown";
  securityCode: string;
  referenceValue: string;
  maskedPhone: string;
  sessionKey: string;
  otpCode: string;
  checkedRegistrationCountry;

  stories: any = null;
  storiesKey: number = 0; // Key to force re-render when stories change
  tapped: number;
  isPaused: boolean = false;
  video: any;
  isWaiting: boolean = false;
  isSmalDevice: boolean = false;
  isMeduimDevice: boolean = false;
  switchButtons: any = false;
  isSN: boolean;
  allCountries;
  currentCountry;
  rmt5VueBridgeSignup: boolean = true;
  rmt5VueBridgeLogin: boolean = true;
  welcomeBridgeEnabled: boolean = false;

  constructor(
    private navCtrl: NavController,
    private navParams: NavParams,
    private platform: Platform,
    private routeProvider: RouteProvider,
    private authProvider: AuthProvider,
    private storageProvider: StorageProvider,
    private customerProvider: CustomerProvider,
    private marketingProvider: MarketingProvider,
    private httpProvider: HttpProvider,
    private appVersion: AppVersion,
    private translate: TranslateService,
    private loadingProvider: LoadingProvider,
    private analytics: SegmentProvider,
    private registerProvider: RegisterProvider,
    private events: Events,
    private deeplinkProvider: DeeplinkProvider,
    private systemProvider: SystemProvider,
    private loginProvider: LoginProvider,
    private utilsProvider: UtilsProvider,
    private modal: ModalController,
    private vueProvider: VueProvider,
    private iovation: IovationProvider,
    private firebase: FirebaseAnalyticsProvider,
    private resourceProvider: ResourceProvider,
    private sendFlowProvider: SendFlowProvider,
    private commonProvider: CommonProvider,
    private alertCtrl: AlertController,
    ) {

    if (APP_CONFIG.env !== Env.PROD)
      this.showEnvironmentConfig = true;

    this.apis = APP_CONFIG.apis ? APP_CONFIG.apis : [];

    this.loadBrandStories();
    this.tapped = this.navParams.get("tapped");
    this.getAppInfo();
    const skipLogout = (this.navParams.get('skipLogout'));
    const isAutoLogBackInBiometric = this.navParams.get('isAutoLogBackInBiometric');
    if (skipLogout)
      LoggerProvider.info(this, 'Skip logout');
    else
      this.authProvider.logoutUser(null, false);
    const redirected = this.navParams.get('redirected');
    if (redirected) {
      this.redirected = true;
      this.showSplashscreen = false;
      LoggerProvider.notice(this, 'Redirected to prelogin page');
    }
    else
      LoggerProvider.notice(this, 'Started in prelogin page');

    this.enterPromise = new Promise((resolve) => {
      this.enterResolve = resolve;
    });

    if(APP_CONFIG.reminderInterval){
      this.reminderDuration = APP_CONFIG.reminderInterval;
    }

    this.switchButtons = UtilsProvider.getFeatureFlagDataUnsafe(FeatureFlagTypes.LandingPageSignInRegisterButtonsPosition);
    LoggerProvider.info(this, `Switch buttons: ${this.switchButtons}`);

    this.platform.ready().then(async () => {
      LoggerProvider.trace(this, 'Platform read in prelogin page');
      if (APP_CONFIG.automationTest) RmtDebugMenuComponent.applyAutomationTestRecaptcha();
      await this.authProvider.lanuageReady;
      await this.checkLiteRegistration(APP_CONFIG.region.defaultCountryFrom);
      await this.registerProvider.checkOpenAgentReferrals();
      let loggedIn = false
      if (isAutoLogBackInBiometric === true || isAutoLogBackInBiometric === null || isAutoLogBackInBiometric === undefined)
        loggedIn = await this.initBiometrics();
      this.resourceProvider.ensureInitializedResources();
    });

    if (this.showEnvironmentConfig) {
      this.updateEnvironmentConfigText();
      this.toggleFrame();
    }

    this.isSN = this.commonProvider.isSN();
    this.init();

    const deepLinkData = this.navParams.get("deepLinkData");
    if(deepLinkData && deepLinkData.action === 'LanguageSelectionPage'){
        window.setTimeout(() => {
          this.language.showPicker();
          this.language.handleDismiss = (lang) => {
            if(lang){
            this.language.handleDismiss = null;
            this.selectLanguage(lang);
            this.language.update();
            }
          }
         }, 250);
    }
  }

  async run() {
    var value = await this.iovation.getIovationBlackbox();
    RmtSnackbarComponent.present("Iovation getIovationBlackbox");
    LoggerProvider.info(this, "Iovation getIovationBlackbox", `${JSON.stringify(value)}`);
  }

  async ionViewWillEnter() {
    if (this.hasEnteredOnce && this.vueProvider.isAnyWelcomeArmEnabled() && !VueBridgeState.isUserInsideVueBridge) {
      this.showSplashscreen = true;
      this.splashScreenOpacity = 1.0;
    }
    if (this.isSN) {
      const allCountries = await this.allCountries;
      if(allCountries)
        this.currentCountry = allCountries.find((countryItem) => countryItem.value === 'SN')
    }
  }

  ionViewWillLoad() {
    this.events.subscribe("displayGenericHome", (isDisplay) => this.displayGenericHome = isDisplay);
  }

  ionViewDidEnter() {
    this.content && this.content.resize();

    if (!this.animLoading) {
      this.animLoading = {
        path: 'assets/anims/ria-loader-coin.json',
        autoplay: false,
        loop: true
      };
    }
    if(this.platform.is("cordova")) {
      if(this.platform.resume) {
        this.playStory();
      }
    }
    this.setStorySeen();
    this.enterPromise = null;
    this.enterResolve(true);
    this.language.update();

    if (this.hasEnteredOnce) {
      this.routeToVueWelcomeIfEnabled();
    }
    this.hasEnteredOnce = true;
  }

  private hasEnteredOnce: boolean = false;

  private async routeToVueWelcomeIfEnabled() {
    if (!this.vueProvider.isAnyWelcomeArmEnabled()) {
      LoggerProvider.info(this, 'DebugMenu: routeToVueWelcomeIfEnabled skip - no welcome arm enabled');
      return;
    }
    if (VueBridgeState.isUserInsideVueBridge) {
      LoggerProvider.info(this, 'DebugMenu: routeToVueWelcomeIfEnabled skip - already inside Vue bridge');
      return;
    }
    LoggerProvider.info(this, 'DebugMenu: routeToVueWelcomeIfEnabled invoking navigate(Welcome)');
    LoggerProvider.notice(this, 'Pre-login re-entered, routing back to Vue Welcome');
    VueBridgeState.setUserInsideVueBridge(true);
    await this.vueProvider.navigate('Welcome', '', {} as any, () => {
      VueBridgeState.setUserInsideVueBridge(false);
      this.hideSplashScreen();
    }, false);
    this.hideSplashScreen();
  }

  ionViewDidLeave() {
    this.storageProvider.checkScreenLockSettings();
    if(this.platform.is("cordova")) {
      if(this.platform.pause) {
        this.pauseStory();
      }
    }
  }

  async init() {
    this.getDeviceDimension();
    try {
      this.offers = [];
      for (let i = 1; i < 100; i++) {
        const marketings = await this.marketingProvider.getAllMarketingsForPage('PreLoginPageOffer' + i);
        if (marketings && marketings.length > 0)
          this.offers.push(marketings);
        else
          break;
      }
    }
    catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Failed to initialze prelogin page');
    }
  }

  async initBiometrics() {
    this.deviceToken = await this.storageProvider.get(StorageType.FingerprintDeviceToken);
    LoggerProvider.info(this, 'DebugMenu: initBiometrics gate', `redirected=${this.redirected} hasDeviceToken=${!!this.deviceToken}`);
    if (!this.redirected || this.deviceToken) {
      const result = await this.checkBiometrics();
      this.content.resize();
      if (!result) {
        LoggerProvider.info(this, 'DebugMenu: initBiometrics no biometric result, calling checkLastLogin');
        this.checkLastLogin();
      }
      return result;
    }
    LoggerProvider.info(this, 'DebugMenu: initBiometrics short-circuit (redirected && no deviceToken) - checkLastLogin skipped');
    return false;
  }

  async checkBiometrics() {
    let hide = false;
    let fingerprintToken;
    let scanFailure: BiometricLoginFailureReason;
    const legacyFingerprintToken = await this.storageProvider.get(StorageType.FingerprintToken);
    if (legacyFingerprintToken) {
      await this.authProvider.saveBiometrics(legacyFingerprintToken, false).then(
        () => {
          this.storageProvider.remove(StorageType.FingerprintToken);
          LoggerProvider.notice(this, 'Legacy Fingerprint Token mechanism updated');
        }
      );
    }
    const deviceToken = await this.storageProvider.get(StorageType.FingerprintDeviceToken); // controls isBiometricEnabled
    await this.httpProvider.waitForConnection();
    if (deviceToken && deviceToken.length > 0) {
      try {
        const available = await this.authProvider.biometricsAvailable();
        if (available) {
          this.showSplashscreen = true;
          this.splashScreenOpacity = 1.0;
          this.faceId = this.authProvider.faceId;
          this.touchId = this.authProvider.touchId;
          const method = (this.faceId) ? 'faceID' : 'touchID';
          await new Promise<void>((resolve) => { window.setTimeout(() => { resolve(); }, 500); }); // delay 500ms so screen has a chance to show

          this.analytics.trackEvent({
            eventName: AnalyticsEventType.LoginStarted, analyticsData: {
              location: SegmentLocationNames.LogIn,
              loginMethod: method,
              pilotUser: SegmentProvider.isPilotUser
            }
          });

          hide = true;
          if (!fingerprintToken) {
            let timeout = window.setTimeout(async () => {
              timeout = null;
              LoggerProvider.warning(this, LoggerEvent.PageException, 'Timeout for biometrics - hide splashscreen');
              this.welcomeBridgeEnabled = this.vueProvider.isAnyWelcomeArmEnabled();
              if (this.welcomeBridgeEnabled) {
                const lastLogin = await this.storageProvider.get(StorageType.LastLogin);
                if (lastLogin) {
                  VueBridgeState.setUserInsideVueBridge(true);
                  await this.vueProvider.navigate('LoginBiometrics', '', await this.vueProvider.getLoginBiometricsData(lastLogin), () => {
                    this.hideSplashScreen();
                  }, false);
                  return;
                }
              }
              this.hideSplashScreen();
            }, 5000);
            const scan = await this.authProvider.readStoredFingerprintToken(method, false);
            fingerprintToken = scan.token;
            scanFailure = scan.reason;
            if (timeout)
              window.clearTimeout(timeout);
          }
          if (fingerprintToken) {
            const biometricsMethod = this.authProvider.getBiometricsMethod(method);
            const params = {
              biometricsMethod: biometricsMethod,
              fingerPrint: fingerprintToken,
              loginToken: fingerprintToken,
              deviceToken: deviceToken,
              deviceId: LoggerProvider.uuid
            }

            try {
              await this.authProvider.signin(params, method, null, SegmentLocationNames.Login); // for biometrics captcha token is not needed

              const result = await this.authProvider.initializeUser(false, false, false, true);
              if (!result) {
                RmtPopupComponent.showError('Failed to initialize automatic login - please try to login manually');
                return false;
              }
              this.authProvider.navigateLogin(params, SegmentLocationNames.Biometrics, false);
              return true;
            }
            catch (ex) {
              if (AuthProvider.isFingerprintTokenRejected(ex)) {
                scanFailure = 'rejected';
              }
              this.hideSplashScreen();
              await this.authProvider.handleAuthErrors(this.routeProvider.pages.PreLoginPage.page,ex,method,params,async() => {
                await this.proceedLogin();
              });
              this.loadingProvider.hide();
            }
          }
          // Auto-scan failed/cancelled — route to Vue LoginBiometrics if landing flag enabled
          this.welcomeBridgeEnabled = this.vueProvider.isAnyWelcomeArmEnabled();
          if (this.welcomeBridgeEnabled) {
            const lastLogin = await this.storageProvider.get(StorageType.LastLogin);
            // A dead key wipes enrollment during the scan, but RMT5 may already be on LoginBiometrics
            // (5s timeout above), so still tell it why the fingerprint can't be used.
            const stillEnrolled = !!await this.storageProvider.get(StorageType.FingerprintDeviceToken);
            const unusable = !!scanFailure && scanFailure !== 'cancelled';
            if (lastLogin && (stillEnrolled || unusable)) {
              VueBridgeState.setUserInsideVueBridge(true);
              await this.vueProvider.navigate('LoginBiometrics', '', await this.vueProvider.getLoginBiometricsData(lastLogin, scanFailure), () => {
                this.hideSplashScreen();
              }, false);
              return false;
            }
          }
          this.hideSplashScreen();
          return false;
        }
      }
      catch (ex) {
        LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Failed to check biometrics in prelogin page');
        if (hide)
          this.loadingProvider.hide();
        this.hideSplashScreen();
      }
    }
    return false;
  }

  async hideSplashScreen() {
    this.splashScreenOpacity = 0.0;
    const language = await this.customerProvider.getStoredLanguage();
    if (language) {
      window.setTimeout(() => {
        this.showSplashscreen = false;
      }, 300);
    } else {
      window.setTimeout(() => {
        this.showSplashscreen = false;
      }, 100);
    }
  }

  async checkLastLogin() {
    if (this.enterPromise)
      await this.enterPromise;

    const lastlogin = await this.storageProvider.get(StorageType.LastLogin);
    if (this.routeProvider.transitionPromise)
      await this.routeProvider.transitionPromise;

    this.welcomeBridgeEnabled = this.vueProvider.isAnyWelcomeArmEnabled();
    LoggerProvider.info(this, 'DebugMenu: checkLastLogin gate', `welcomeBridgeEnabled=${this.welcomeBridgeEnabled} hasLastLogin=${!!lastlogin} insideVue=${VueBridgeState.isUserInsideVueBridge} lastActive=${this.routeProvider.getLastActivePage()} lastPushed=${this.routeProvider.getLastPushedPage() ? this.routeProvider.getLastPushedPage().page : null}`);

    if ((lastlogin || this.welcomeBridgeEnabled) &&
      this.navCtrl.getActive() &&
      !VueBridgeState.isUserInsideVueBridge &&
      this.routeProvider.getLastActivePage() !== this.routeProvider.pages.SigninPage.page &&
      (!this.routeProvider.getLastPushedPage() || this.routeProvider.getLastPushedPage().page === this.routeProvider.pages.PreLoginPage.page)) {

      this.rmt5VueBridgeLogin = UtilsProvider.getFeatureFlagDataUnsafe(FeatureFlagTypes.Rmt5VueBridgeLogin);
      const country = await this.utilsProvider.getSelectedCountry();
      if(!this.welcomeBridgeEnabled && APP_CONFIG.env !== Env.PROD) {
        this.welcomeBridgeEnabled = APP_CONFIG.automationTest && (country === 'PT');
      }
      if(!this.rmt5VueBridgeLogin && APP_CONFIG.env !== Env.PROD) {
        this.rmt5VueBridgeLogin = APP_CONFIG.automationTest && (country === 'PT');
      }

      if (lastlogin) {
        const deviceToken = await this.storageProvider.get(StorageType.FingerprintDeviceToken);
        const biometricsAvailable = deviceToken && deviceToken.length > 0 && await this.authProvider.biometricsAvailable();
        if (biometricsAvailable && this.welcomeBridgeEnabled) {
          LoggerProvider.notice(this, 'Has last login + biometrics, navigating to Vue LoginBiometrics');
          VueBridgeState.setUserInsideVueBridge(true);
          await this.vueProvider.navigate('LoginBiometrics', '', await this.vueProvider.getLoginBiometricsData(lastlogin), () => {
            this.routeProvider.push(this.routeProvider.pages.SigninPage);
            this.hideSplashScreen();
          }, false);
        } else if (this.welcomeBridgeEnabled) {
          LoggerProvider.notice(this, 'Has last login, no biometrics, navigating to Vue Welcome');
          VueBridgeState.setUserInsideVueBridge(true);
          await this.vueProvider.navigate('Welcome', '', { username: lastlogin } as any, () => {
            this.routeProvider.push(this.routeProvider.pages.SigninPage);
            this.hideSplashScreen();
          }, false);
        } else if (this.rmt5VueBridgeLogin) {
          LoggerProvider.notice(this, 'Has last login, no landing flag, navigating to Vue Login');
          VueBridgeState.setUserInsideVueBridge(true);
          await this.vueProvider.navigate('Login', '', { username: lastlogin } as any, () => {
            this.routeProvider.push(this.routeProvider.pages.SigninPage);
            this.hideSplashScreen();
          }, false);
        } else {
          await this.routeProvider.push(this.routeProvider.pages.SigninPage);
        }
      } else if (this.welcomeBridgeEnabled) {
        LoggerProvider.notice(this, 'No last login, navigating to Vue Welcome');
        LoggerProvider.info(this, 'DebugMenu: checkLastLogin invoking navigate(Welcome) - no last login branch');
        VueBridgeState.setUserInsideVueBridge(true);
        await this.vueProvider.navigate('Welcome', '', {} as any, () => {
          this.hideSplashScreen();
        }, false);
      }
      this.hideSplashScreen();
    } else {
      LoggerProvider.info(this, 'DebugMenu: checkLastLogin gate not met - staying native, hiding splash');
      this.hideSplashScreen();
    }
  }

  logout() {
    if (HttpProvider.hasAuthCustomerId()) {
      this.httpProvider.resetAuthToken();
      this.authProvider.logout();
    }

  }

  async navigateRegister(isSocialLogin: boolean = false, registerPayload: any = null) {
     /* As per ticket OM-14436, we need to recheck the user's location 
     when they click on Registration to ensure we capture their current 
     location rather than the previously stored one */

     this.rmt5VueBridgeSignup = UtilsProvider.getFeatureFlagDataUnsafe(FeatureFlagTypes.Rmt5VueBridgeSignup);

     try {
      this.loadingProvider.showDelayed();
      await this.httpProvider.reinitialiseAuthCountry();
      
      this.registerProvider.lastLiteRegistrationFlow = this.registerProvider.isLiteRegistrationFlow();
      const country = await this.utilsProvider.getSelectedCountry();
      // if(!this.rmt5VueBridgeSignup && APP_CONFIG.env !== Env.PROD) {
      //   this.rmt5VueBridgeSignup = APP_CONFIG.automationTest && UtilsProvider.getFeatureFlagDataUnsafe(FeatureFlagTypes.Rmt5VueBridgeSignup);
      // }
      this.loadingProvider.hide();

      if (this.rmt5VueBridgeSignup) {
        VueBridgeState.setUserInsideVueBridge(true);
      }

      await this.analytics.trackEvent({
        eventName: AnalyticsEventType.RegistrationStarted, analyticsData: {
          location: SegmentLocationNames.Landing,
          country: country,
          registrationFlowType: this.registerProvider.lastLiteRegistrationFlow ? SegmentLocationNames.LiteRegistrationFlow : SegmentLocationNames.FullRegistrationFlow,
          pilotUser: SegmentProvider.isPilotUser,
          ...getSourceAnalyticsData()
        }
      });
      this.analytics.flush();

      this.logout();

      if (this.rmt5VueBridgeSignup) {
        const pendingFrom = await this.storageProvider.get(StorageType.WelcomePendingCountryFrom);
        const pendingTo = await this.storageProvider.get(StorageType.WelcomePendingCountryTo);
        const navData: any = {};
        if (pendingFrom) navData.countryFrom = pendingFrom;
        if (pendingTo) navData.countryTo = pendingTo;
        this.vueProvider.navigate('RegistrationCountry', '', navData, () => {
          this.navigateRegisterInApp();
        }, true); // Show loading while bridge connects
      } else {
        await this.navigateRegisterInApp();
      }
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.RegistrationPage, "Error in navigating to register");
      this.loadingProvider.hide();
    }
  }

  async navigateRegisterInApp() {
      if (this.branding.branding != brandings.Walmart.branding) {
        if (this.isSN) {
          this.routeProvider.push(this.routeProvider.pages.RegistrationStepUsernamePage, { selectedCountry: this.currentCountry });
          return;
        }
        const pendingFrom = await this.vueProvider.consumePendingWelcomeCountry();
        if (pendingFrom) {
          await this.continueRegistration(pendingFrom);
          return;
        }
          // Always move user to new country selection flow.
          this.redirectToCountrySelectionPage();
      }
      else if (this.branding.branding == brandings.Walmart.branding) {
        const country = await this.selectWalmartDefaultCountry();
        this.registerProvider.setCurrentRegistration({});
        this.utilsProvider.refreshCountryFeatures();
        this.routeProvider.push(this.routeProvider.pages.RegistrationStep1Page, { selectedCountry: country })
      }
  }

  redirectToCountrySelectionPage() {
    this.openModal(this.routeProvider.pages.RlUserCountryPage, {
      analyticsLocation: SegmentLocationNames.Registration,
      onChangeCountry: (country) => {
        this.continueRegistration(country);
      }
    });
  }

  async checkLiteRegistration(country) {
    try {
      await this.utilsProvider.checkIsLiteRegistrationSettingEnabled();
      this.checkedRegistrationCountry = country;
    } catch(ex) {
      RmtPopupComponent.showExceptionWithLogTranslation(this, '', 'global.myRia.jsonContent.OopsInfo');
      this.utilsProvider.setIsLiteRegistrationEnabled(false); // don't block registration
    }
  }

  async continueRegistration(country) {
    // eventually the country has changed hence we need to update it
    if (country !== this.checkedRegistrationCountry) {
      this.loadingProvider.showDelayed();
      await this.checkLiteRegistration(country);
      this.loadingProvider.hide();
    }

    this.registerProvider.setCurrentRegistration({}); // reset current registration
    let params = { selectedCountry: country };
    await this.utilsProvider.continueRegistrationPage(params);
  }

  async selectWalmartDefaultCountry() {
    const country = { value: 'US', text: 'United States', countryCode: '1' } // default country for WMT will be US
    const alreadySetcountry = await this.storageProvider.get(StorageType.UserCountry);
    if (alreadySetcountry == null || alreadySetcountry != country.value)
      await this.authProvider.setUserCountry(country.value, true, true, true, false, false);
    return country;
  }

  async navigateSignIn() {

    this.rmt5VueBridgeLogin = UtilsProvider.getFeatureFlagDataUnsafe(FeatureFlagTypes.Rmt5VueBridgeLogin);

    const country = await this.utilsProvider.getSelectedCountry();
    if(!this.rmt5VueBridgeLogin && APP_CONFIG.env !== Env.PROD) {
      this.rmt5VueBridgeLogin = APP_CONFIG.automationTest && (country === 'PT');
    }

    if (this.rmt5VueBridgeLogin) {
      VueBridgeState.setUserInsideVueBridge(true);
    }

    this.analytics.trackEvent({ eventName: AnalyticsEventType.LoginAccessed, analyticsData: {location: SegmentLocationNames.Landing} });

    this.logout();
    if (this.redirected || this.deviceToken) {
      const result = await this.checkBiometrics();
      if (result)
        return;
      else if (!result) {
        const deviceToken = await this.storageProvider.get(StorageType.FingerprintDeviceToken);
        if (deviceToken && deviceToken.length > 0)
          LoggerProvider.warning(this, LoggerEvent.PageException, 'Check biometrics: cancelled');
        else
          LoggerProvider.info(this, LoggerEvent.PageException, 'Check biometrics: not available');
      }
    }
    if (this.rmt5VueBridgeLogin) {
      const lastLogin = await this.storageProvider.get(StorageType.LastLogin);
      const vueLoginData: any = lastLogin ? { username: lastLogin } : {};

      this.vueProvider.navigate('LoginRMT5', '', vueLoginData, () => {
        this.routeProvider.push(this.routeProvider.pages.SigninPage);
      }, true);
    } else {
      this.routeProvider.push(this.routeProvider.pages.SigninPage);
    }
  }

  async navigateCheckPrices() {
    this.logout();

    const country = await this.storageProvider.get(StorageType.UserCountry);
    if (country) {
      const defaultCountry = await this.storageProvider.get(StorageType.DefaultCountryTo);
      if (defaultCountry)
        this.openModal(this.routeProvider.pages.CheckPricesPage, { defaultCountry });
      else
        this.sendFlowProvider.showCountryPicker();
    } else
      if (this.branding.branding == brandings.Walmart.branding) {
        await this.selectWalmartDefaultCountry();
        this.openModal(this.routeProvider.pages.CheckPricesPage);
      }
      else
        this.openModal(this.routeProvider.pages.UserCountryPage, {
          analyticsLocation: SegmentLocationNames.CheckPrices
        });
  }

  openModal(page, params = {}, triggerLeave = true) {
    // when opening a modal leave is not called but it is very important to call it to ensure the screen lock screen has been shown
    // otherwise the storage won't work properly in consequent pages
    if (triggerLeave)
      this.ionViewDidLeave();
    this.routeProvider.openModal(page, params,()=>{
      if( page.page == "UserCountryPage"){
        if(this.platform.is("cordova")) {
          if(this.platform.resume) {
            this.playStory();
          }
        }
      }
    });
  }

  selectLanguage(lang) {
    this.analytics.trackEvent({
      eventName: AnalyticsEventType.LanguageSelected, analyticsData: {
        location: 'landing screen',
        language: lang,
      }
    });

    this.customerProvider.setLanguage(lang).then(()=>{
      this.language.update();
    });
  }

  onDebugMenuBrandingChanged() {
    this.branding = APP_CONFIG.branding;
    this.stories = null;
    window.setTimeout(() => {
      this.loadBrandStories();
      this.storiesKey++;
      window.setTimeout(() => {
        if (this.stories && this.stories.length > 0) {
          this.stories.forEach(story => {
            story.currentItem = 0;
            story.seen = false;
            if (story.items) {
              story.items.forEach(item => item.seen = false);
            }
          });
          if (this.slides) {
            this.slides.update();
            this.slides.slideTo(0, 0);
          }
        }
      }, 150);
    }, 50);
  }

  onDebugMenuDone(result) {
    LoggerProvider.info(this, 'DebugMenu: onDebugMenuDone entry', JSON.stringify(result));
    this.environment = APP_CONFIG.env;
    this.api = APP_CONFIG.API_URL;
    this.updateEnvironmentConfigText();
    this.switchButtons = UtilsProvider.getFeatureFlagDataUnsafe(FeatureFlagTypes.LandingPageSignInRegisterButtonsPosition);
    this.rmt5VueBridgeLogin = UtilsProvider.getFeatureFlagDataUnsafe(FeatureFlagTypes.Rmt5VueBridgeLogin);
    this.welcomeBridgeEnabled = this.vueProvider.isAnyWelcomeArmEnabled();
    this.showEnvironmentConfigDetails = false;

    const overridesChanged = !!(result && result.rmt5OverridesChanged);
    const settingsChanged = !!(result && result.settingsChanged);
    LoggerProvider.info(this, 'DebugMenu: onDebugMenuDone flags', `overridesChanged=${overridesChanged} settingsChanged=${settingsChanged} welcomeBridgeEnabled=${this.welcomeBridgeEnabled}`);

    if (overridesChanged) {
      this.vueProvider.reloadBridgeAfterFlagChange(false)
        .then(() => {
          LoggerProvider.info(this, 'DebugMenu: onDebugMenuDone bridge reload sync phase done, scheduling cold-boot rebuild');
          window.requestAnimationFrame(() => this.rebuildPreLoginAfterDebugMenu(false));
        })
        .catch((ex) => {
          LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Failed to reload Vue bridge after flag change');
          window.requestAnimationFrame(() => this.rebuildPreLoginAfterDebugMenu(false));
        });
    } else if (settingsChanged) {
      LoggerProvider.info(this, 'DebugMenu: onDebugMenuDone env/api changed - legacy refresh (redirected baked)');
      window.requestAnimationFrame(() => this.rebuildPreLoginAfterDebugMenu(true));
    } else {
      LoggerProvider.info(this, 'DebugMenu: onDebugMenuDone no changes - overlay close only, no setRoot');
    }
  }

  private rebuildPreLoginAfterDebugMenu(legacyRefresh: boolean) {
    // When no Vue welcome arm is active (e.g. RMT5 Legacy mode), the Vue-Welcome
    // path that hides the intro splash never runs — so suppress the splash
    // (redirected: true) to keep the native prelogin from hanging on the spinner.
    const noVueWelcome = !this.vueProvider.isAnyWelcomeArmEnabled();
    const params = legacyRefresh ? {} : { skipLogout: true, redirected: noVueWelcome };
    LoggerProvider.info(this, 'DebugMenu: onDebugMenuDone inside rAF, calling setRoot PreLoginPage', `legacyRefresh=${legacyRefresh}`);
    const setRootPromise = this.routeProvider.setRoot(this.routeProvider.pages.PreLoginPage, params, false);
    if (setRootPromise && setRootPromise.then) {
      setRootPromise
        .then(() => LoggerProvider.info(this, 'DebugMenu: onDebugMenuDone setRoot resolved'))
        .catch((ex) => LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'DebugMenu: onDebugMenuDone setRoot rejected'));
    } else {
      LoggerProvider.info(this, 'DebugMenu: onDebugMenuDone setRoot returned no promise (skipped/bailed)');
    }
  }

  async getAppInfo() {
    this.appInfo = await this.systemProvider.getAppReleaseInfo()
  }

  async proceedLogin() {
    const result = await this.authProvider.initializeUser(false, false, false, true);
    this.loadingProvider.hide();
    if (!result) {
      RmtPopupComponent.showError('Failed to initialize automatic login - please try to login manually');
      return false;
    }
    this.authProvider.loginFirstRedirection();
    return true;
  }

    ngAfterViewInit() {
      if (this.videoRef) {
        this.video = this.videoRef.nativeElement;
        this.video.muted = true; // without this line it's not working although I have "muted" in HTML
        this.video.onwaiting = () => { this.isWaiting = true; };
        this.video.onready = this.video.onload = this.video.onplaying = this.video.oncanplay = () => { this.isWaiting = false; };
        if(!this.showSplashscreen){

          this.video.addEventListener("loadedmetadata", () => {
            let storyVideo = this.getCurrentStoryItem();
            if (this.video.duration && !storyVideo.duration) storyVideo.duration = this.video.duration;
            this.video.play();
          });
         }
      }else {
        if (this.video) this.video = null;
      }

    this.slides.initialSlide = this.tapped;
  }

  getCurrentStory() {
    return this.stories[0];
  }

  nextStoryItem() {
    if (this.getCurrentStory().currentItem < this.getCurrentStory().items.length - 1) {
      this.getCurrentStory().currentItem++;
      this.setStorySeen();
    }else {
      if (this.slides.isEnd()) {
        this.getCurrentStory().currentItem = 0 ;
      }
    }
  }

  pauseStory() {
    this.isPaused = true;
    var vids = document.getElementsByTagName('video') ;
    for( var i = 0; i < vids.length; i++ ){
      vids.item(i).pause() ;
   }
  }

  playStory() {
    this.isPaused = false;
    var vids = document.getElementsByTagName('video') ;
    for( var i = 0; i < vids.length; i++ ){
      vids.item(i).play() ;
   }
  }

  getCurrentStoryItem() {
    let currentStory = this.getCurrentStory();
    if (currentStory) return currentStory.items[currentStory.currentItem];
  }

  isLoading(indexStory: number): boolean {
      let storyItem = this.getCurrentStoryItem();
      if (storyItem && this.isWaiting == false)  {
        return !storyItem.duration && storyItem.type == 1 && indexStory === this.slides.getActiveIndex();
      } else {
        return true;
      }
  }

  changeStoryItem(event: any, story: any) {
      if (event.center.y < 70 || event.center.y > this.platform.height() - 70) return;

      if (event.center.x < this.platform.width() / 2) {
        if (story.currentItem > 0) {
          story.currentItem--;
          this.setStorySeen();
        }
      } else {
        this.nextStoryItem();
      }
  }

  setStorySeen() {
    let story = this.getCurrentStory();
    let storyItem = this.getCurrentStoryItem();
    if (!storyItem.seen) {
      if (story.currentItem === story.items.length - 1) story.seen = true;
      storyItem.seen = true;
    }
  }

  toggleFrame(refresh = true) {
    APP_CONFIG.previewFrame = this.showFrame;
    let before = document.body.className;
    if (this.showFrame)
      $(document.body).addClass('preview-frame');
    else
      $(document.body).removeClass('preview-frame');

    if (refresh && before !== document.body.className)
      window.requestAnimationFrame(() => {
        this.routeProvider.setRoot(this.routeProvider.pages.PreLoginPage);
      });
  }

  updateEnvironmentConfigText() {
    let apiDesc = this.api;
    for (let i = 0; i < this.apis.length; i++) {
      const api = this.apis[i];
      if (api.cst === apiDesc) {
        apiDesc = api.text;
        break;
      }
    }
    this.environmentConfigText = this.environment + ' • ' + apiDesc + ' • ' + this.branding.branding;
    if (APP_CONFIG.automationTest)
      this.environmentConfigText += ' • automation'
    if (this.showFrame)
      this.environmentConfigText += ' • show frame'
  }

  maximizeEnvironmentConfig() {
    this.updateEnvironmentConfigText()
    this.showEnvironmentConfigDetails = true;
  }

  getDeviceDimension() {
    this.platform.ready().then(() => {

    const width = this.platform.width();
    const height = this.platform.height();

    if (width <= 390 && height <= 667) {
      this.isSmalDevice = true;
    } else if (width <= 430 && height <= 932) {
      this.isMeduimDevice = true;
    }
  });
  }


  loadBrandStories() {
    try {
      const brandName = this.branding.branding.toLowerCase();

      // Try to load brand-specific stories
      try {
        // Create a deep copy to ensure Angular detects the change
        const loadedStories = require(`../../assets/prismicDoc/${brandName}/stories.json`);
        this.stories = JSON.parse(JSON.stringify(loadedStories));
        LoggerProvider.info(this, `Loaded stories for brand: ${brandName}`);
      } catch (ex) {
        // Fallback to RIA if brand stories not found
        LoggerProvider.warning(this, LoggerEvent.PageException, `Stories not found for ${brandName}, falling back to RIA`);
        const riaStories = require('../../assets/prismicDoc/ria/stories.json');
        this.stories = JSON.parse(JSON.stringify(riaStories));
      }
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Failed to load stories');
      this.stories = []; // Set empty stories to prevent errors
    }
  }

  trackByStoryIndex(index: number, story: any): any {
    return this.storiesKey + '_' + index;
  }

  trackByItemIndex(index: number, item: any): any {
    return index;
  }

  onSecretTap() {
    HiddenMenuProvider.handleSecretTap(this.alertCtrl, this.storageProvider, this.httpProvider, this.analytics);
  }
}



// WEBPACK FOOTER //
// ./src/pages/pre-login-stories/pre-login-stories.ts